import './stage.scss';
import Rellax from 'rellax';

class Stage {
    constructor (element) {
        this.$stage = element;
        this.$stageImage = this.$stage.querySelector('.stage__image-holder');
        this.$$videos = this.$stage.querySelectorAll('video');
    }

    initialize () {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.$$videos.forEach(($video) => {
                $video.pause();
            });
        } else {
            this.setEvents();
        }
    }

    setEvents () {
        this.setParallax();
    }

    setParallax () {
        if (this.$stageImage) {
            const animated = this.$stageImage.getAttribute('animated');
            if (animated === null) {
                new Rellax(this.$stageImage, {
                    speed: 3.75,
                    center: false,
                    wrapper: null,
                    round: true,
                    vertical: true,
                    horizontal: false
                });

                this.$stageImage.setAttribute('animated', true);
            }
        }
    }
}

export { Stage };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-stage="root"]');
        $$roots.forEach($root => {
            const $rootAPI = new Stage($root);
            $rootAPI.initialize();
        });
    }
});
